import React from 'react';
import SocialButton from '../SocialButton';
import useRoute from '@/Hooks/useRoute';

export default function SocialAuth() {
  const route = useRoute();
  return (
    <div className="border-b-brand-dark-35 grid w-full grid-cols-3 justify-between gap-x-4 border-b py-4">
      <SocialButton href={route('auth.redirect', 'google')} type="google" />
      <SocialButton href={route('auth.redirect', 'facebook')} type="facebook" />
      <SocialButton href={route('auth.redirect', 'github')} type="github" />
    </div>
  );
}
